var render = function render(){var _vm=this,_c=_vm._self._c;return _c('baseTemplate',[_c('div',{staticClass:"about-us-box"},[_c('Logo'),_c('div',{staticClass:"v-box"},[_vm._v("V"+_vm._s(_vm.$andirodData.Ubwafwilisho_Application))]),_c('div',{staticClass:"about-us-content",domProps:{"innerHTML":_vm._s(_vm.$t('settings.aboutUsRemark'))}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }